exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[dir=ltr] .upload-as-modal-icon{margin-right:1rem}[dir=rtl] .upload-as-modal-icon{margin-left:1rem}", ""]);

